<script>
  import { afterUpdate, createEventDispatcher, onMount } from "svelte";
  import { fly, slide } from "svelte/transition";
  import InfoSVG from "./InfoSVG.svelte";

  export let delay = 2500;
  export let text = "";
  export let error = false;

  let oldText = text;
  let timer;

  const dispatch = createEventDispatcher();

  afterUpdate(() => {
    if (text !== oldText) {
      open();
      oldText = text;
    }
  });

  onMount(() => {
    open();
    return () => {
      clearTimeout(timer);
    };
  });

  export function open() {
    console.log("start timer");
    clearTimeout(timer);
    timer = setTimeout(close, delay);
  }

  export function close() {
    clearTimeout(timer);
    dispatch("close");
  }
</script>

<div
  class="container"
  role="none"
  transition:fly={{ y: 100 }}
  on:click={(ev) => {
    ev.preventDefault();
    close();
  }}
>
  <div class="emoji">
    {#if error}⚠️{:else}
      <InfoSVG></InfoSVG>
    {/if}
  </div>
  <div class="caption" class:error>{text}</div>
</div>

<style>
  .container {
    position: fixed;
    user-select: none;
    cursor: pointer;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    width: max-content;
    margin: auto;
    margin-bottom: 40px;
    background: white;
    border: 1px solid black;
    box-shadow:
      0px 3px 0px black,
      3px 0px 0px black,
      3px 3px 0px black;
    padding: 20px;
    /* border-top: 1px solid black; */
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  .emoji {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .error {
    color: #c51919;
  }
</style>
